import { useEffect } from 'react';
import { useTypedSelector } from '@redux/Hooks/storeSelectors';
import { selectIsDrawMode, selectLayerClickabilityById } from '@redux/selectors/selectors';
import { useToastContext } from '@context/toastContext';

type Props = {
    layerId: string;
    toastMsg: string;
    showWarning?: boolean;
};

const LockedLayerNotifier = ({ layerId, toastMsg, showWarning }: Props) => {
    const layerClickable = useTypedSelector(state => selectLayerClickabilityById(state, layerId));
    const isDrawMode = useTypedSelector(selectIsDrawMode);
    const { addToast } = useToastContext();

    useEffect(() => {
        if (layerId && !isDrawMode && (!layerClickable || showWarning)) {
            addToast(toastMsg, 'warning');
        }
    }, [layerId, layerClickable, showWarning, isDrawMode]);

    return null;
};

export default LockedLayerNotifier;
